import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { LanguageContext } from '../contexts/LanguageContext';
import { getHeadingFontClass } from '../utils/fontUtils';
import SectionLayout from '../components/SectionLayout';

export default function Vision() {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  return (
    <SectionLayout
      accent="none"
      className="!pt-[100px] !pb-[140px] vision-section-bg"
    >
      <h2
        className="section-title animate-scaleIn"
        style={{ animationDelay: '0.3s' }}
      >
        {intl.formatMessage({ id: 'vision.title' })}
      </h2>
      <p
        className="section-subtitle animate-fadeInUp text-muted-foreground"
        style={{ animationDelay: '0.6s' }}
      >
        {intl.formatMessage({ id: 'vision.subtitle' })}
      </p>
      <div className="animate-fadeInUp" style={{ animationDelay: '0.8s' }}>
        <h3
          className={`text-2xl lg:text-4xl font-bold text-foreground leading-normal mb-6 ${getHeadingFontClass(locale)}`}
        >
          {intl.formatMessage({ id: 'vision.heading' })}
        </h3>
        <p className="text-base sm:text-lg md:text-xl text-muted-foreground leading-loose md:leading-loose font-body">
          {intl.formatMessage({ id: 'vision.description' })}
        </p>
      </div>
    </SectionLayout>
  );
}
